import MainDrawer from '../components/drawers/MainDrawer'
import ProfileSettingsDrawer from '../components/drawers/ProfileSettingsDrawer'

export default {
  methods: {
    openMainDrawer () {
      this.$store.dispatch('drawer/open', {
        drawer: MainDrawer,
      })
    },
    openProfileSettingsDrawer () {
      this.$store.dispatch('drawer/open', {
        drawer: ProfileSettingsDrawer,
      })
    },
  },
}
